module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "materCode"
    }
  }, [_c('el-col', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-form', {
    ref: "searchForm",
    attrs: {
      "model": _vm.searchForm,
      "inline": true,
      "label-width": "100px",
      "label-position": _vm.labelPosition
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "15px",
      "width": "150px"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "请选择品牌"
    },
    on: {
      "change": _vm.showBrand
    },
    model: {
      value: (_vm.defaultBrandId),
      callback: function($$v) {
        _vm.defaultBrandId = $$v
      },
      expression: "defaultBrandId"
    }
  }, _vm._l((_vm.brandLists), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.brandName,
        "value": item.brandId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "15px",
      "width": "150px"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "请选择品类"
    },
    on: {
      "change": _vm.showCategory
    },
    model: {
      value: (_vm.defaultCategoryId),
      callback: function($$v) {
        _vm.defaultCategoryId = $$v
      },
      expression: "defaultCategoryId"
    }
  }, _vm._l((_vm.categoryLists), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.categoryName,
        "value": item.categoryId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "15px",
      "width": "150px"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "请选择型号"
    },
    on: {
      "change": _vm.showModel
    },
    model: {
      value: (_vm.defaultModelId),
      callback: function($$v) {
        _vm.defaultModelId = $$v
      },
      expression: "defaultModelId"
    }
  }, _vm._l((_vm.modelLists), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.modelName,
        "value": item.modelId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "15px",
      "width": "150px"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "请选择物料分类"
    },
    on: {
      "change": _vm.showClass
    },
    model: {
      value: (_vm.defaultClassificationId),
      callback: function($$v) {
        _vm.defaultClassificationId = $$v
      },
      expression: "defaultClassificationId"
    }
  }, _vm._l((_vm.classDialogList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.classificationName,
        "value": item.classificationId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "15px",
      "width": "150px"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "maxlength": "50",
      "placeholder": "请输入物料名称"
    },
    model: {
      value: (_vm.searchForm.materialName),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "materialName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "searchForm.materialName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "15px",
      "width": "150px"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "请输入物料编号"
    },
    model: {
      value: (_vm.searchForm.materialCode),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "materialCode", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "searchForm.materialCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "启用状态："
    }
  }, [_c('el-switch', {
    attrs: {
      "active-value": 1,
      "inactive-value": -1
    },
    model: {
      value: (_vm.defaultInitiateMode),
      callback: function($$v) {
        _vm.defaultInitiateMode = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "defaultInitiateMode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.onSubmit()
      }
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "60px",
      "color": "#169BD5"
    },
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.clearFrom()
      }
    }
  }, [_vm._v("重置")])], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "fr"
  }, [_c('el-col', {
    staticStyle: {
      "text-align": "right"
    }
  }, [(_vm.basicsAuth.insertMaterialManagement) ? _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "success"
    },
    on: {
      "click": _vm.createMater
    }
  }, [_vm._v("新建物料")]) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "el-icon-refresh",
    staticStyle: {
      "font-size": "25px",
      "cursor": "pointer",
      "margin-left": "30px"
    },
    on: {
      "click": function($event) {
        return _vm.refresh()
      }
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-card', {
    staticClass: "box-card"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.returnData,
      "border": "",
      "header-cell-style": {
        'text-align': 'center'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "materialCode",
      "label": "物料编号",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "materialName",
      "label": "物料名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "brandName",
      "label": "品牌"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "categoryName",
      "label": "品类"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "modelName",
      "label": "型号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "classificationName",
      "label": "物料类型"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "initiateMode",
      "label": "状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.initiateMode == '1') ? _c('span', [_vm._v("启用")]) : _vm._e(), _vm._v(" "), (scope.row.initiateMode == '-1') ? _c('span', [_vm._v("停用")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), (_vm.basicsAuth.updateMaterialManagement) ? _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.exitBtn(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")])]
      }
    }], null, false, 3432076914)
  }) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "current-page": _vm.pages.page,
      "page-sizes": [10, 20, 50, 100],
      "page-size": _vm.pages.pageSize,
      "layout": "total, sizes, prev, pager, next,jumper",
      "total": _vm.pages.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.textMenu[_vm.dialogMenuStatus],
      "visible": _vm.dislogCreate,
      "close-on-click-modal": false,
      "width": "600px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dislogCreate = $event
      },
      "close": function($event) {
        return _vm.emptyDialog('materForm')
      }
    }
  }, [_c('el-form', {
    ref: "materForm",
    attrs: {
      "model": _vm.materForm,
      "rules": _vm.materFormRules,
      "label-width": "100px",
      "label-position": _vm.labelPosition
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "物料编号：",
      "prop": "materialCode"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "disabled": _vm.canSet,
      "placeholder": "请输入物料编号(不超过15位数)",
      "maxlength": "15"
    },
    model: {
      value: (_vm.materForm.materialCode),
      callback: function($$v) {
        _vm.$set(_vm.materForm, "materialCode", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "materForm.materialCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "物料名称：",
      "prop": "materialName"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "请输入物料名称(不超过50个字)",
      "maxlength": "50"
    },
    model: {
      value: (_vm.materForm.materialName),
      callback: function($$v) {
        _vm.$set(_vm.materForm, "materialName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "materForm.materialName"
    }
  })], 1), _vm._v(" "), (_vm.createStutas) ? _c('el-form-item', {
    attrs: {
      "label": "选择品牌：",
      "prop": "brandId"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "请选择品牌"
    },
    on: {
      "change": _vm.getBrand
    },
    model: {
      value: (_vm.materForm.brandId),
      callback: function($$v) {
        _vm.$set(_vm.materForm, "brandId", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "materForm.brandId"
    }
  }, _vm._l((_vm.brandLists), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.brandName,
        "value": item.brandId
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.createStutas) ? _c('el-form-item', {
    attrs: {
      "label": "选择品类：",
      "prop": "categoryId"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "请选择品类"
    },
    on: {
      "change": _vm.getCategory
    },
    model: {
      value: (_vm.materForm.categoryId),
      callback: function($$v) {
        _vm.$set(_vm.materForm, "categoryId", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "materForm.categoryId"
    }
  }, _vm._l((_vm.categoryLists), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.categoryName,
        "value": item.categoryId
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.createStutas) ? _c('el-form-item', {
    attrs: {
      "label": "选择型号：",
      "prop": "modelId"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "请选择型号"
    },
    on: {
      "change": _vm.getModel
    },
    model: {
      value: (_vm.materForm.modelId),
      callback: function($$v) {
        _vm.$set(_vm.materForm, "modelId", $$v)
      },
      expression: "materForm.modelId"
    }
  }, _vm._l((_vm.modelLists), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.modelName,
        "value": item.modelId
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.createStutas) ? _c('el-form-item', {
    attrs: {
      "label": "选择分类：",
      "prop": "classificationId"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "请选择分类"
    },
    on: {
      "change": _vm.getClassDialogLists
    },
    model: {
      value: (_vm.materForm.classificationId),
      callback: function($$v) {
        _vm.$set(_vm.materForm, "classificationId", $$v)
      },
      expression: "materForm.classificationId"
    }
  }, _vm._l((_vm.classDialogList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.classificationName,
        "value": item.classificationId
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "启用状态："
    }
  }, [_c('el-switch', {
    attrs: {
      "active-value": 1,
      "inactive-value": -1
    },
    model: {
      value: (_vm.materForm.initiateMode),
      callback: function($$v) {
        _vm.$set(_vm.materForm, "initiateMode", $$v)
      },
      expression: "materForm.initiateMode"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.dialogMenuStatus !== 'update') ? _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.addEventFormSubmitBtn('materForm')
      }
    }
  }, [_vm._v("添加")]) : _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.saveEventFormSubmitBtn('materForm')
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.emptyDialog('materForm')
      }
    }
  }, [_vm._v("取 消")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-29bf6ea9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/basicSetting/materCode.vue
// module id = 1609
// module chunks = 0